export default {_name:'image.avatar',module:'Field',view:'Element/Image/Avatar',options:{key:'avatar'}}